<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <!-- Per Page -->
          <list-per-page
            :total="total"
            :current-per-page="perPage"
            @onChangePerPage="changePerPage"
          />
          <b-button
            v-if="$can('create','services')"
            variant="success"
            @click="createButtonClicked"
          >
            {{ $t('add service') }}
            <feather-icon icon="PlusIcon" />
          </b-button>
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <list-search @onSearch="search" />
          </div>
        </b-col>
      </b-row>
    </div>
    <table-loader v-if="loader" />
    <services-list
      v-else
      :fields="fields"
      :items="items"
      :sort-key="sortKey"
      :sort-type="sortType"
      :additional-data="additionalData"
      :list-filters="additionalData.filters"
      :filters="filters"
      @onSortByChange="changeSortKey"
      @onSortDescChange="changeSortType"
      @onFilterChange="filterChange"
      @onFilterButtonClicked="getData"
      @onDeleteButtonClicked="deleteButtonClicked"
    />

    <list-pagination
      :current="page"
      :current-per-page="perPage"
      :from="from"
      :to="to"
      :total="total"
      :total-page="totalPage"
      @onChangePage="changePage"
    />
  </b-card>
</template>

<script>
import { ListIndex } from '../../common/mixins/list'
import ServicesList from '../../components/services/list/ServicesList'

export default {
  components: {
    ServicesList,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'services',
      userFields: [
        {
          key: 'status',
          label: this.$t('Status'),
        },
        {
          key: 'expire_at',
          label: this.$t('Expire at'),
          sortable: true,
        },
      ],
      adminFields: [
        {
          key: 'id',
          label: this.$t('Id'),
          sortable: true,
        },
        {
          key: 'user',
          label: this.$t('User'),
        },
        {
          key: 'name',
          label: this.$t('Package'),
        }, {
          key: 'number_of_accounts',
          label: this.$t('Number of accounts'),
        },
        // {
        //   key: 'webhook',
        //   label: this.$t('Webhook'),
        // },
        {
          key: 'messages_count',
          label: this.$t('Messages count'),
        },
        {
          key: 'status',
          label: this.$t('Status'),
        },
        {
          key: 'expire_at',
          label: this.$t('Expire at'),
          sortable: true,
        },
        {
          key: 'action',
          label: '',
        },
      ],
    }
  },
}
</script>

<style lang="scss">

</style>
